import { FC } from 'react';

// eslint-disable-next-line unicorn/no-null
const NullComponent: FC = () => null;

export default NullComponent;
